import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_74: FaireProductEntity = {
  token: "catalog_prod_prod-74",
  type: "product",
  name: "Linen Table Runner - Natural - Style 3",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop",
  priceDollars: 67.14,
  msrpDollars: 167.85,
  sku: "JA0074",
  caseSize: 4,
  material: "Cotton",
  collectionToken: "col_japandi",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 35,
  description: "Beautiful Japandi piece perfect for any home.",
  categoryTokens: ["catalog_cat_mens-accessories"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
